import { useContext } from 'react';

import { AdminContext } from './AdminProvider';

export default function useAdminTools() {
  return useContext(AdminContext);
}
